import { IMeeting } from "../types";

const isCrossingMeeting = (meetingStartDate: Date, meetingEndDate: Date, itemStartDate: Date, itemEndDate: Date) => {
  const meetingStart = meetingStartDate.getTime();
  const meetingEnd = meetingEndDate.getTime();

  const currentStartDate = itemStartDate.getTime();
  const currentEndDate = itemEndDate.getTime();

  // если meeting началась раньше и (конец позже или конец во время item)
  return (
    meetingStart <= currentStartDate
    && meetingEnd <= currentEndDate
    && meetingEnd > currentStartDate
  )
    || (meetingStart <= currentStartDate && meetingEnd > currentEndDate);
};

export const getMeetingWithLayer = (
  layer: number, item: IMeeting, meetings?: IMeeting[],
): IMeeting => meetings
  ?.some((meeting) =>
    isCrossingMeeting(meeting.startDate, meeting.endDate, item.startDate, item.endDate) && layer === meeting.layer
  )
    ? getMeetingWithLayer(layer + 1, item, meetings)
    : { ...item, layer };

export const getLayer = (
  layer: number, startDate: Date, endDate: Date, meetings?: IMeeting[],
): number => meetings
  ?.some((meeting) =>
    isCrossingMeeting(meeting.startDate, meeting.endDate, startDate, endDate) && layer === meeting.layer
  )
    ? getLayer(layer + 1, startDate, endDate, meetings)
    : layer;